module.exports = __webpack_public_path__ + "img/media_1.8be9729c.png";